import { useRequiredPrepMillisecond } from "@/components/features/items/edit/_shared/ui/components/main/questions/required-prep-milli";

import { useProductPlanFormModelContext } from "../../../../context";

export const usePlanRequiredPrepMillisecond = () => {
	const { viewModel, onSetViewModel } = useProductPlanFormModelContext();
	const { requiredPrepMillisecondBeforeHour, requiredPrepMillisecondBeforeDate, requiredPrepMillisecond } = viewModel;

	return useRequiredPrepMillisecond({
		requiredPrepMillisecond,
		requiredPrepMillisecondBeforeDate,
		requiredPrepMillisecondBeforeHour,
		onSet: onSetViewModel,
	});
};
